import Dashboard2 from "./dashboard2";
import TabelFeedbackSupplier from "./ratingsupplier";
import TabelFeedbackCustomer from "./tabelfeedbackcustomer";
import DaftarStock from "../../mainscreen/pesananscreen/daftarStock";
import { RencanaProduksiChart } from "./rencanaproduksichart";
import { LaporanProduksiChart } from "./laporanproduksichart";
import Dashboard5 from "./dashboard5";
import PriceUploadTable from "../manajemenpengguna.js/manajemenuploadharga";

export default function Dashboard() {
  const roleId = parseInt(localStorage.getItem("roleId"), 10);

  return (
    <div className="relative h-full w-full p-3">
      {/* Content */}
      <div className="flex flex-col gap-4 relative pb-8">
        {/* <Dashboard1 /> */}
        <Dashboard2 />
        {/* <DashboardRev1/> */}
        <div className="grid grid-rows-1 gap-4 lg:grid-rows-[auto_1fr] w-full">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 w-full">

            {roleId !== 6 ? (
            <div className="rounded-[20px] bg-[#EEEFF1] flex items-center w-full border border-gray-400">
              <Dashboard5 />
            </div>
            ) : null}

            {roleId === 3 || roleId === 5 ? (
              <div className="rounded-[20px] bg-[#EEEFF1] border flex items-center w-full border-gray-400">
                <RencanaProduksiChart />
              </div>
            ) : null}

            {roleId !== 6 ? (
            <div className="rounded-[20px] bg-[#EEEFF1] flex items-center w-full border border-gray-400">
              <LaporanProduksiChart />
            </div>
            ) : null}

          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Item 2 */}
            {roleId === 3 || roleId === 4 ? (
              <div className="rounded-[20px] bg-[#EEEFF1] border border-gray-400">
                <TabelFeedbackSupplier tombol={true} jumlahdata={3} />
              </div>
            ) : null}

            {/* Item 3 */}
            {roleId === 3 || roleId === 4 ? (
              <div className="rounded-[20px] bg-[#EEEFF1] border border-gray-400">
                <DaftarStock tombol={true} />
              </div>
            ) : null}
          </div>
        </div>
        {/* Full-width item */}
        {roleId === 3 || roleId === 4 ? (
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <div className="rounded-[20px] bg-[#EEEFF1] border border-gray-400">
              <TabelFeedbackCustomer tombol={true} jumlahdata={3} />
            </div>
          </div>
        ) : null}
        {/* Full-width item */}
        {roleId === 6 ? (
          <div className="col-span-1 md:col-span-2 lg:col-span-3 grid gap-4">
            <div className="rounded-[20px] bg-[#EEEFF1] border border-gray-400">
              <PriceUploadTable tombol={true} jumlahdata={3} />
            </div>
              <div className="rounded-[20px] bg-[#EEEFF1] border border-gray-400">
                <TabelFeedbackSupplier tombol={true} jumlahdata={3} />
              </div>
          </div>
        ) : null}
        {roleId === 5 ? (
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <div className="rounded-[20px] bg-[#EEEFF1] border border-gray-400">
              <TabelFeedbackCustomer tombol={true} jumlahdata={3} />
            </div>
              <div className="rounded-[20px] bg-[#EEEFF1] border border-gray-400 mt-10">
                <TabelFeedbackSupplier tombol={true} jumlahdata={3} />
              </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
